import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Checkbox } from "..";
import "./AuthForm.scss";
import { CaptchaWidget } from "../CaptchaWidget/CaptchaWidget";

function LoginForm({
  onSwitchToRegister,
  onSubmit,
  onForgotPassword,
  errorMessage,
  infoMessage,
  loggingIn,
  setLoggingIn,
  setCaptchaToken,
  turnstileRef,
  registraciaZapnuta = false,
  onOdkazNaRegistraciu,
}) {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [zapamatat, setZapamatat] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loggingIn) {
      return;
    }
    setLoggingIn(true);
    onSubmit?.({ email, password, username, rememberMe: zapamatat });
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      {infoMessage && <p className="auth-form__hint" role="status">{infoMessage}</p>}
      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="login-username">
          Prihlasovacie meno
        </label>
        <input
          id="login-username"
          type="text"
          className="auth-form__input"
          placeholder="Meno alebo e-mail"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
        />
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="login-password">
          Heslo
        </label>
        <input
          id="login-password"
          type="password"
          className="auth-form__input"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />
      </div>

      <div className="auth-form__row auth-form__row--split">
        {/* "Zapamätať si ma" ponúkame vždy, ale server ho vyhovie iba
            zákazníkovi (R18). Obsluhe ostáva 8-hodinová relácia, lebo na jej
            obrazovkách sú údaje všetkých zákazníkov. */}
        <Checkbox
          id="login-remember"
          checked={zapamatat}
          onChange={setZapamatat}
          label="Zapamätať si ma"
        />
        <button
          type="button"
          className="auth-form__link"
          onClick={onForgotPassword}
        >
          Zabudnuté heslo?
        </button>
      </div>
      <CaptchaWidget
        onVerify={(token) => setCaptchaToken(token)}
        turnstileRef={turnstileRef}
      />

      {errorMessage && <div className="auth-form__error">{errorMessage}</div>}

      <div className="auth-form__submit">
        <Button
          variant="primary"
          type="submit"
          style={{ width: "100%" }}
          disabled={loggingIn}
        >
          {loggingIn ? "Prihlasujem..." : "Prihlásiť sa"}
        </Button>
      </div>

      {/* Registrácia je samostatná stránka, nie ďalší modál (R41) -- je na nej
          aj mapa s adresami a do modálu sa to rozumne nezmestí. */}
      {registraciaZapnuta && (
        <p className="auth-form__switch">
          Nemáte účet?{" "}
          <Link to="/registracia" className="auth-form__link" onClick={onOdkazNaRegistraciu}>
            Zaregistrujte sa
          </Link>
        </p>
      )}
    </form>
  );
}

export default LoginForm;
